/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { INosSubscriptionListViewProps } from './nos-subscription-list';

export default (props: INosSubscriptionListViewProps) => {
    const { table, heading, className } = props;

    return (
        <div className={className}>
            {heading}
            {table}
        </div>
    );
};
